var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("site-nav"),
      _vm._v(" "),
      !["index", "store", "productDetail"].includes(this.$route.name) &&
      this.terminal === 4
        ? _c("cere-header", {
            attrs: { componentContent: _vm.componentContent }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("div", { staticClass: "main" }, [_c("router-view")], 1),
      _vm._v(" "),
      _c("Footer"),
      _vm._v(" "),
      _c("loading-toast", { ref: "loadingToast" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-loader/node_modules/vue-hot-reload-api")      .rerender("data-v-55bc5258", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-55bc5258","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/views/layout_b2c.vue
// module id = null
// module chunks = 